import axios from 'axios'
import Const from '@/helper/const'

export default {
  checkCardFlag (params) {
    return axios({
      method: 'get',
      url: `${Const.API_MERCADO_PAGO}/v1/payment_methods/installments`,
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        ...params,
        public_key: Const.MERCADO_PAGO_PUBLIC_KEY(),
        locale: 'pt#json'
      }
    })
  }
}
